'use client';

import dynamic from 'next/dynamic';

// Dynamically import to avoid SSR issues
const HelpCommandPalette = dynamic(
  () => import('./help-command-palette').then((mod) => ({ default: mod.HelpCommandPalette })),
  { ssr: false }
);

export function HelpCommandPaletteWrapper() {
  return <HelpCommandPalette />;
}
